import {environment} from './../../../environments/environment';
import * as uuid from 'uuid';
import {catchError, lastValueFrom, take} from 'rxjs';

import {ALLOWED_IMAGE_TYPES, ALLOWED_IMAGE_TYPES_WARNING, IMAGE_UPLOAD_MAX_SIZE} from './../../app.constants';
import {Options} from 'ngx-quill-upload';
import {WikiItemDetailComponent} from '../wiki-item-detail/wiki-item-detail.component';

type QuillConfigProps = {
  that: WikiItemDetailComponent;
};

export const getWikiItemQuillConfig = (props: QuillConfigProps) => {
  const {that} = props;
  //This might get added in later
  // imageResize: {modules: ['Resize', 'DisplaySize']},
  return {
    imageCompress: {
      //default values
      quality: 0.9,
      maxWidth: 400,
      maxHeight: 1000,
      imageType: 'image/jpeg',
      debug: false,
      suppressErrorLogging: false,
      insertIntoEditor: undefined,
    },
    imageHandler: {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      upload: (file: File): Promise<any> => {
        // eslint-disable-next-line no-async-promise-executor
        return new Promise(async (resolve, reject) => {
          if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
            that.messageService.add(ALLOWED_IMAGE_TYPES_WARNING);
            return reject('Unsupported type');
          }
          if (file.size > IMAGE_UPLOAD_MAX_SIZE * 1024 * 1024) {
            that.messageService.add(`Image size must be below ${IMAGE_UPLOAD_MAX_SIZE}MB`);
            return reject('Size too large');
          }
          const uploadData = new FormData();
          // Makes the file name a unique id to avoid overwriting in s3 bucket if images have same name
          that.user$.pipe(take(1)).subscribe(user => {
            const originalFileName: string = file.name;
            const ogFileNameWoSpaces = originalFileName.replaceAll(' ', '_');
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            const fileName = encodeURIComponent(`${user._id}/${uuid.v4()}_${ogFileNameWoSpaces}`);
            uploadData.append('file', file, fileName);
          });

          try {
            const result = await lastValueFrom(
              that.http.post(`${environment.apiUrl}/imageUpload`, uploadData).pipe(
                catchError(error => {
                  reject('Upload failed');
                  throw error;
                })
              )
            );
            that.imageAdded.emit(result);
            resolve(result);
          } catch (error) {
            reject('Upload failed');
          }
        });
      },

      fetch: (url: string, callback: Function) => {
        that.http.get(url).subscribe(
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          (res: any) => {
            callback(res.url);
          },
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          (error: any) => {
            console.error('Error fetching image:', error);
            callback('');
          }
        );
      },
      accepts: ['png', 'jpg', 'jpeg', 'gif'],
    } as Options,
  };
};

export const WIKI_ITEM_QUILL_STYLES = {
  borderRight: '1px solid #E5E3DC',
  borderLeft: '1px solid #E5E3DC',
  borderBottom: '1px solid #E5E3DC',
  borderBottomLeftRadius: '8px',
  borderBottomRightRadius: '8px',
  fontFamily: 'Asap',
  fontSize: '16px',
  width: '100%',
  height: '85% !important',
  maxHeight: '85% !important',
  backgroundColor: 'var(--lightest, #fefdf5)',
};
